import "./Header.scss"

import logo from "../../assets/logo_PFAE.webp"

export default function() {
  
  return(<header className="Header">
    <div className="hWraper">
      <img src={logo} alt="Logo asesores clave" onClick={_=>window.location.href="https://asesoresclave.com/"}/>

      <a href="https://asesoresclave.com/broker/">Afíliate</a>
    </div>
  </header>)
}